var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { hasData: _vm.isInformation, loading: _vm.isLoading } },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col w-full relative additionalTab justify-between items-start bg-white p-6",
        },
        [
          _c("div", { staticClass: "relative w-full mb-10" }, [
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-row justify-between items-start w-full",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg text-primary-black",
                    },
                    [
                      _vm._v(" Websites "),
                      _c("span", { staticClass: "totalNumber ml-0.5" }, [
                        _vm._v(_vm._s(_vm.getWebsiteLength)),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex flex-row items-center" },
                    [
                      _c("UiButton", {
                        staticClass: "absolute",
                        class:
                          _vm.websitesByManagement.length > 0
                            ? "right-4"
                            : "right-auto",
                        attrs: {
                          label:
                            _vm.websitesByManagement.length > 0
                              ? `edit`
                              : `add black`,
                        },
                        on: {
                          click: () => {
                            _vm.showManagementAddContractorInfoModal = true
                            _vm.managementAddedInfoMode.website = true
                          },
                        },
                      }),
                      _vm.websitesByManagement.length > 0
                        ? _c("UiButton", {
                            staticClass: "absolute right-0",
                            attrs: { label: "delete black" },
                            on: {
                              click: () => {
                                _vm.showManagementAddContractorInfoModal = true
                                _vm.managementAddedInfoMode.website = true
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              !!_vm.websitesByManagement.length || _vm.websitesByResource
                ? _c("div", { staticClass: "parentBox flex flex-col gap-3" }, [
                    !!_vm.websitesByManagement.length
                      ? _c(
                          "div",
                          _vm._l(_vm.websitesByManagement, function (website) {
                            return _c(
                              "span",
                              {
                                key: website.name,
                                staticClass: "flex flex-row items-center",
                              },
                              [
                                _c("ManagementIcon", {
                                  staticClass: "w-4 h-4 mr-4",
                                }),
                                website
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "text-light-green hover:text-badgeBlue text-base font-normal truncate no-underline customLineH",
                                        attrs: {
                                          href: website.name,
                                          target: "”_blank”",
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(website.name) + " ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm.websitesByResource
                      ? _c("div", [
                          _c(
                            "span",
                            { staticClass: "flex items-center" },
                            [
                              _c("UserProfileIcon", {
                                staticClass: "w-4 h-4 mr-4",
                              }),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "resourceBlue hover:text-badgeBlue text-base font-normal overflow-auto break-words no-underline customLineH",
                                  attrs: {
                                    href: _vm.websitesByResource,
                                    target: "”_blank”",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.websitesByResource) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _c(
                    "div",
                    { staticClass: "font-normal text-base text-gray-new" },
                    [_vm._v("No website added.")]
                  ),
            ]),
          ]),
          _c("div", { staticClass: "relative w-full mb-10" }, [
            _c(
              "div",
              {
                staticClass: "flex flex-row justify-between items-start w-full",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg text-primary-black",
                  },
                  [
                    _vm._v(" Emails "),
                    _c("span", { staticClass: "totalNumber ml-0.5" }, [
                      _vm._v(" " + _vm._s(_vm.getEmailsLength) + " "),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-row items-center" },
                  [
                    _c("UiButton", {
                      staticClass: "absolute",
                      class:
                        _vm.emailByManagement.length > 0
                          ? "right-4"
                          : "right-auto",
                      attrs: {
                        label:
                          _vm.emailByManagement.length > 0
                            ? `edit`
                            : `add black`,
                      },
                      on: {
                        click: () => {
                          _vm.showManagementAddContractorInfoModal = true
                          _vm.managementAddedInfoMode.email = true
                        },
                      },
                    }),
                    _vm.emailByManagement.length > 0
                      ? _c("UiButton", {
                          staticClass: "absolute right-0",
                          attrs: { label: "delete black" },
                          on: {
                            click: () => {
                              _vm.showManagementAddContractorInfoModal = true
                              _vm.managementAddedInfoMode.email = true
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            !!_vm.emailByManagement.length || _vm.emailsByResource
              ? _c("div", [
                  _c("div", { staticClass: "parentBox flex flex-col gap-3" }, [
                    !!_vm.emailByManagement.length
                      ? _c(
                          "div",
                          _vm._l(_vm.emailByManagement, function (email) {
                            return _c(
                              "span",
                              {
                                key: email.name,
                                staticClass: "flex flex-row items-center",
                              },
                              [
                                _c("ManagementIcon", {
                                  staticClass: "w-4 h-4 mr-4",
                                }),
                                _c("MailTo", {
                                  staticClass:
                                    "text-light-green hover:text-badgeBlue text-base overflow-auto break-words font-normal customLineH",
                                  attrs: { email: email.name },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm.emailsByResource
                      ? _c("div", [
                          _c(
                            "span",
                            { staticClass: "flex items-center" },
                            [
                              _c("UserProfileIcon", {
                                staticClass: "w-4 h-4 mr-4",
                              }),
                              _c("MailTo", {
                                staticClass:
                                  "resourceBlue hover:text-badgeBlue text-base overflow-auto break-words font-normal customLineH",
                                attrs: { email: _vm.emailsByResource },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _c(
                  "div",
                  { staticClass: "font-normal text-base text-gray-new" },
                  [_vm._v("No email added.")]
                ),
          ]),
          _c("div", { staticClass: "relative w-full mb-10" }, [
            _c(
              "div",
              {
                staticClass: "flex flex-row justify-between items-start w-full",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg text-primary-black",
                  },
                  [
                    _vm._v(" Work Phone "),
                    _c("span", { staticClass: "totalNumber ml-0.5" }, [
                      _vm._v(_vm._s(_vm.getphoneLength)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-row items-center" },
                  [
                    _c("UiButton", {
                      staticClass: "absolute",
                      class:
                        _vm.phoneByManagement.length > 0
                          ? "right-4"
                          : "right-auto",
                      attrs: {
                        label:
                          _vm.phoneByManagement.length > 0
                            ? `edit`
                            : `add black`,
                      },
                      on: {
                        click: () => {
                          _vm.showManagementAddContractorInfoModal = true
                          _vm.managementAddedInfoMode.phone = true
                        },
                      },
                    }),
                    _vm.phoneByManagement.length > 0
                      ? _c("UiButton", {
                          staticClass: "absolute right-0",
                          attrs: {
                            label:
                              !!_vm.phoneByManagement.length && `delete black`,
                          },
                          on: {
                            click: () => {
                              _vm.showManagementAddContractorInfoModal = true
                              _vm.managementAddedInfoMode.phone = true
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _vm.phoneByManagement.length > 0 || _vm.phoneByResource
              ? _c("div", { staticClass: "parentBox flex flex-col gap-3" }, [
                  _vm.phoneByManagement.length > 0
                    ? _c(
                        "div",
                        _vm._l(_vm.phoneByManagement, function (phone) {
                          return _c(
                            "span",
                            {
                              key: phone.name,
                              staticClass: "flex flex-row items-center",
                            },
                            [
                              _c("ManagementIcon", {
                                staticClass: "w-4 h-4 mr-4",
                              }),
                              _c("PhoneTo", {
                                staticClass:
                                  "block underline font-normal text-base text-lightGreen hover:text-badgeBlue no-underline customLineH",
                                attrs: { phone: phone.name },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.phoneByResource
                    ? _c("div", [
                        _c(
                          "span",
                          { staticClass: "flex items-center" },
                          [
                            _c("UserProfileIcon", {
                              staticClass: "w-4 h-4 mr-4",
                            }),
                            _c("PhoneTo", {
                              staticClass:
                                "resourceBlue hover:text-badgeBlue text-base font-normal no-underline leading-none customLineH",
                              attrs: { phone: _vm.phoneByResource },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              : _c(
                  "div",
                  { staticClass: "font-normal text-base text-gray-new" },
                  [_vm._v("No phone number added.")]
                ),
          ]),
          _c("div", { staticClass: "relative w-full mb-10" }, [
            _c(
              "div",
              {
                staticClass: "flex flex-row justify-between items-start w-full",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg text-primary-black",
                  },
                  [
                    _vm._v(" Location "),
                    _c("span", { staticClass: "totalNumber ml-0.5" }, [
                      _vm._v(_vm._s(_vm.getLocationLength)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-row items-center" },
                  [
                    _c("UiButton", {
                      staticClass: "absolute",
                      class:
                        _vm.locationByManagement.length > 0
                          ? "right-4"
                          : "right-auto",
                      attrs: {
                        label:
                          _vm.locationByManagement.length > 0
                            ? `edit`
                            : `add black`,
                      },
                      on: {
                        click: () => {
                          _vm.showManagementAddContractorInfoModal = true
                          _vm.managementAddedInfoMode.city = true
                        },
                      },
                    }),
                    _vm.locationByManagement.length > 0
                      ? _c("UiButton", {
                          staticClass: "absolute right-0",
                          attrs: { label: "delete black" },
                          on: {
                            click: () => {
                              _vm.showManagementAddContractorInfoModal = true
                              _vm.managementAddedInfoMode.city = true
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _vm.locationByManagement.length > 0 || _vm.locationByResource
              ? _c("div", { staticClass: "parentBox flex flex-col" }, [
                  _vm.locationByManagement.length !== 0
                    ? _c(
                        "div",
                        _vm._l(_vm.locationByManagement, function (location) {
                          return _c(
                            "span",
                            {
                              key: location.id,
                              staticClass: "flex flex-row items-center",
                            },
                            [
                              _c("ManagementIcon", {
                                staticClass: "w-4 h-4 mr-4",
                              }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "block underline font-normal text-base text-lightGreen hover:text-badgeBlue no-underline customLineH",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(location.address) +
                                      _vm._s(
                                        location.address && location.city && ","
                                      ) +
                                      " " +
                                      _vm._s(location.city) +
                                      _vm._s(
                                        location.state && location.city && ","
                                      ) +
                                      " " +
                                      _vm._s(location.state) +
                                      _vm._s(
                                        location.state &&
                                          location.city &&
                                          location.postal_code &&
                                          ","
                                      ) +
                                      " " +
                                      _vm._s(location.postal_code) +
                                      _vm._s(
                                        location.state &&
                                          location.city &&
                                          location.postal_code &&
                                          location.country &&
                                          ","
                                      ) +
                                      " " +
                                      _vm._s(location.country) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.locationByResource
                    ? _c(
                        "div",
                        {
                          class:
                            _vm.locationByManagement.length !== 0 && `mt-3`,
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "flex items-center" },
                            [
                              _c("UserProfileIcon", {
                                staticClass: "w-4 h-4 mr-4",
                              }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "resourceBlue hover:text-badgeBlue text-base font-normal no-underline customLineH",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.locationByResource) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _c(
                  "div",
                  { staticClass: "font-normal text-base text-gray-new" },
                  [_vm._v("No location added.")]
                ),
          ]),
          _vm.showManagementAddContractorInfoModal
            ? _c("ManagementAddContractorInfo", {
                attrs: {
                  managementAddedInfoMode: _vm.managementAddedInfoMode,
                  userId: _vm.contractorUserId,
                  profileByManagement: _vm.profilesByManagement.find(
                    (profile) => {
                      if (profile.added_by_id === _vm.currentUserId)
                        return profile
                    }
                  ),
                },
                on: {
                  close: () => {
                    _vm.showManagementAddContractorInfoModal = false
                    Object.assign(
                      _vm.managementAddedInfoMode,
                      _vm.managementAddedInfoModeInit
                    )
                  },
                  refreshContractor: () => {
                    _vm.$apollo.queries.profilesByManagement.refetch()
                    _vm.$apollo.queries.contractorDetails.refetch()
                  },
                  refetchProfileByManagement: () => {
                    _vm.processing = true
                    _vm.$apollo.queries.contractorDetails.refetch()
                    _vm.$apollo.queries.profilesByManagement.refetch()
                    _vm.processing = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }